var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPoAmount(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 11.5H2.2C1.88174 11.5 1.57652 11.3595 1.35147 11.1095C1.12643 10.8594 1 10.5203 1 10.1667V4.83333C1 4.47971 1.12643 4.14057 1.35147 3.89052C1.57652 3.64048 1.88174 3.5 2.2 3.5H11.8C12.1183 3.5 12.4235 3.64048 12.6485 3.89052C12.8736 4.14057 13 4.47971 13 4.83333V8.16667",
    stroke: "#525676",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0781 13.502V9.83594",
    stroke: "#525676",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8281 11.5859L11.0781 9.83594L9.32812 11.5859",
    stroke: "#525676",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99512 5.83594C7.91544 5.83611 8.66113 6.58256 8.66113 7.50293C8.66096 8.42315 7.91533 9.16877 6.99512 9.16895C6.07475 9.16895 5.3283 8.42325 5.32812 7.50293C5.32812 6.58246 6.07464 5.83594 6.99512 5.83594Z",
    stroke: "#525676",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoAmount);
export default __webpack_public_path__ + "static/media/poAmount.45446e265a272a1e89d01506838e0484.svg";
export { ForwardRef as ReactComponent };